import type { FaireProductEntity } from "../../entity_types/product";

export const p_k4raz2z9sr: FaireProductEntity = {
  token: "p_k4raz2z9sr",
  type: "product",
  name: "Bouquet candle gift set",
  brandToken: "b_qkzg5xrxcd",
  brandName: "Cue",
  imageUrl:
    "https://cdn.faire.com/fastly/4d0831b3f230de4c9a0136f230bd57da5319bf8cdcc95c2df05ee886fdcb719d.jpeg",
  galleryImageUrls: [],
  priceDollars: 15,
  description:
    "A blooming trio of 3.5oz tin candles featuring Apple Rose, Lavender Eucalyptus and Wild Honeysuckle.\n",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:05.610Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
